import React, { FC } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';

type Props = {
  message: string;
  title: string;
  onClose: (isConfirm: boolean) => void;
  open: boolean;
};

export const ConfirmationDialog: FC<Props> = ({ onClose, open, message, title }) => {
  const handleCancel = () => {
    onClose(false);
  };

  const handleOk = () => {
    onClose(true);
  };

  return (
    <Dialog sx={{ '& .MuiDialog-paper': { width: '80%', maxHeight: 435 } }} maxWidth="xs" open={open}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent dividers>{message}</DialogContent>
      <DialogActions>
        <Button autoFocus onClick={handleCancel}>
          Cancel
        </Button>
        <Button onClick={handleOk} data-testid="cart-confirmation-ok-btn">
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  );
};
